'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _moment = require('moment');

var _moment2 = _interopRequireDefault(_moment);

var _commonFunctions = require('../../helpers/commonFunctions');

var _dateFunctions = require('../../helpers/dateFunctions');

var _dateFunctions2 = _interopRequireDefault(_dateFunctions);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (formConfig, formValues, trackingCode) {
  var applicant = formValues.applicant,
      _formValues$applicati = formValues.application,
      additional_data = _formValues$applicati.additional_data,
      effective_date = _formValues$applicati.effective_date,
      expiry_date = _formValues$applicati.expiry_date;


  var data = _extends({}, (0, _commonFunctions.transformApplication)(formValues, trackingCode), {
    expiry_date: (0, _commonFunctions.isMultiTrip)(formValues) ? (0, _moment2.default)(effective_date).add(364 + _dateFunctions2.default.getLeapYearDay(effective_date, 364), 'days').format('YYYY-MM-DD') : expiry_date
  });

  data.additional_data.travelling_through_the_us = (0, _commonFunctions.isMultiTrip)(formValues) || (0, _commonFunctions.destinationCA_US)(formValues) ? null : formValues.application.additional_data.travelling_through_the_us;
  data.additional_data.home_province = formValues.application.additional_data.home_province;

  return data;
};


//////////////////
// WEBPACK FOOTER
// ./src/v2/transformers/tugo/application.js
// module id = 1763
// module chunks = 0